module.exports = ".title-modal2{color:#4e4d4d;font-size:18px}\n"